import { BaseClient } from 'src/common-services/clients/base-client'
import {
  AMOwnershipPOCExternal,
  AMOwnershipPOCGetEnrichInfoRequest,
  AMOwnershipPOCGetFromParcelRequest,
  AMOwnershipPOCGetFromParcelTaxAssesorIdRequest,
} from 'src/common-services/types/alphamap'
import { PDLPeople } from 'src/server/clients/people-data-labs-client'

export class OwnershipClientPoc extends BaseClient {
  getTest(request: AMOwnershipPOCGetFromParcelRequest): Promise<AMOwnershipPOCExternal> {
    return this.call<any>(`/v2/ownership-legacy/${request.taxAssessorId}`, 'POST', {
      data: request,
    })
  }

  getByParcelTaxAssesorId(request: AMOwnershipPOCGetFromParcelTaxAssesorIdRequest): Promise<AMOwnershipPOCExternal> {
    return this.call<any>(`/v2/ownership-poc/parcel/${request.taxAssessorId}`, 'GET', {
      data: request,
    })
  }

  getEnrichInfo(request: AMOwnershipPOCGetEnrichInfoRequest): Promise<PDLPeople[]> {
    return this.call<PDLPeople[]>(`/v2/ownership-poc/enrich-info`, 'POST', {
      data: request,
    })
  }
}
